export default __webpack_public_path__ + "static/media/dcfcWired.1ab6982e.svg";